import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';

export class TicketSettings extends DataModel {
  static readonly TYPE_ID: string = '196f8ef6d29a41a9bedb64b5ced8eebe';

  private constructor(
    public readonly organizationInfo: string,
  ) {
    super();
  }

  get $typeId(): string {
    return TicketSettings.TYPE_ID;
  }

  static create(args: {
    organizationInfo: string,
  }) {
    return new TicketSettings(
        args.organizationInfo,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): TicketSettings {
    return this.create({
      organizationInfo: MapUtils.getString(map, 'organizationInfo'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'organizationInfo': this.organizationInfo,
    };
  }

  clone(): this {
    return this.copyWith();
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.organizationInfo === this.organizationInfo;
  }

  copyWith({
    organizationInfo = this.organizationInfo,
  }: {
    organizationInfo?: string,
  } = {}): this {
    return TicketSettings.create({
      organizationInfo,
    }) as this;
  }
}

export class TicketSettingsBuilder extends DataModelBuilder<TicketSettings> {
  build(context: SerializationContext, map: SerializedData): TicketSettings {
    return TicketSettings.fromMap(context, map);
  }
}
